import { apiConnection } from "@/services/api-connection";
import { notificationManager } from "@/services/utilities/notification-manager";
import { i18n } from "@/i18n";
import { stringManager } from "@/services/utilities/string-manager";
import { loginManager } from "@/services/security/login-manager";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";

const URL_MENU = "/app/admin/menu";
const URL_MODULE = "/app/admin/module";
const URL_GENERATE_TRIAD_TEST = "/app/admin/training/generate-triad-test";
const URL_GENERATE_TRAINING_TEST = "/app/admin/training/generate-training-test";
const URL_USER_RESET_PASSWORD = "/app/admin/user/generate-password";
const URL_USER_LAST_PASSWORD_LINK = "/app/admin/user/last-password-link/";
const URL_SKILL_CONFIG = "/app/admin/skill/config";
const URL_TRAINING_COURSE = "/app/admin/training-course";

class AdminManager {
  STUDEA_ADMIN_TRAINING = "STUDEA_ADMIN_TRAINING";
  STUDEA_ADMIN_INSTITUTION = "STUDEA_ADMIN_INSTITUTION";
  STUDEA_ADMIN_DEGREE = "STUDEA_ADMIN_DEGREE";
  STUDEA_ADMIN_CONTRACT_TYPE = "STUDEA_ADMIN_CONTRACT_TYPE";
  STUDEA_ADMIN_PLAN_CONTRACT = "STUDEA_ADMIN_PLAN_CONTRACT";
  STUDEA_ADMIN_TITLE_RNCP = "STUDEA_ADMIN_TITLE_RNCP";
  STUDEA_ADMIN_DESIGN = "STUDEA_ADMIN_DESIGN";
  STUDEA_ADMIN_TEMPLATE = "STUDEA_ADMIN_TEMPLATE";
  STUDEA_ADMIN_HELP = "STUDEA_ADMIN_HELP";
  STUDEA_ADMIN_DOCUMENT = "STUDEA_ADMIN_DOCUMENT";
  STUDEA_ADMIN_DATA_AGREEMENT = "STUDEA_ADMIN_DATA_AGREEMENT";
  STUDEA_ADMIN_HISTORY = "STUDEA_ADMIN_HISTORY";
  STUDEA_ADMIN_YPAREO_REPORTING = "STUDEA_ADMIN_YPAREO_REPORTING";
  STUDEA_ADMIN_EDUSIGN_REPORTING = "STUDEA_ADMIN_EDUSIGN_REPORTING";
  STUDEA_ADMIN_AMMON_REPORTING = "STUDEA_ADMIN_AMMON_REPORTING";
  STUDEA_ADMIN_MAIL = "STUDEA_ADMIN_MAIL";
  STUDEA_ADMIN_STATISTIC = "STUDEA_ADMIN_STATISTIC";
  STUDEA_ADMIN_EXPORT = "STUDEA_ADMIN_EXPORT";
  STUDEA_ADMIN_DUPLICATE = "STUDEA_ADMIN_DUPLICATE";
  STUDEA_ADMIN_ARCHIVE = "STUDEA_ADMIN_ARCHIVE";
  STUDEA_ADMIN_MODULE = "STUDEA_ADMIN_MODULE";
  STUDEA_ADMIN_USER = "STUDEA_ADMIN_USER";
  STUDEA_ADMIN_ROLE = "STUDEA_ADMIN_ROLE";
  STUDEA_ADMIN_NEWS = "STUDEA_ADMIN_NEWS";

  ADMIN_REFERENTIAL_ROUTES = [
    "adminSkillReferentialEdit",
    "adminSkillCategoryAdd",
    "adminSkillCategoryEdit",
    "adminSkillAdd",
    "adminSkillEdit",
    "adminSkillImport",
  ];

  ADMIN_REFERENTIAL_ADD_ROUTES = ["adminSkillAdd", "adminSkillCategoryAdd"];

  ADMIN_ALIAS_TO_DISPLAY_HELP = ["document"];

  getMenu() {
    return apiConnection.get(URL_MENU, [], true).then((response) => response);
  }

  getSkillConfig() {
    return apiConnection.get(URL_SKILL_CONFIG).then((response) => response);
  }

  resetUserPassword(id) {
    return apiConnection.get(URL_USER_RESET_PASSWORD + "/" + id, [], true).then((response) => response);
  }

  putModule(datas, id) {
    return apiConnection.put(URL_MODULE + "/" + id, datas, true).then((response) => response);
  }

  putModuleTrainingCourses(datas, id) {
    return apiConnection.put(URL_MODULE + "/" + id + "/training-courses", datas, true).then((response) => response);
  }

  getModuleTrainingCourseEditForm(traininingCourseId) {
    return apiConnection.get(URL_MODULE + "/form/" + traininingCourseId + "/training-courses").then((res) => res);
  }

  sortModule(id, index) {
    return apiConnection.put(URL_MODULE + "/sort/" + id + "/" + index, [], true).then((response) => response);
  }

  list(alias, generic = false, params = {}) {
    return apiConnection
      .get("/app/admin/" + (generic ? "generic/" : "") + encodeURI(alias) + "/list", params)
      .then((response) => response);
  }

  get(alias, id) {
    return apiConnection.get("/app/admin/" + encodeURI(alias) + "/" + id).then((response) => response);
  }

  form(alias, id = null, params = {}, generic = false, search = false, unique = false) {
    return apiConnection
      .get(
        "/app/admin/" +
          (generic ? "generic/" : "") +
          encodeURI(alias) +
          (search ? "/search" : "") +
          "/" +
          (unique ? "unique-" : "") +
          "form" +
          (id ? "/" + id : ""),
        params,
      )
      .then((response) => response);
  }
  put(alias, id = null, params = {}, generic = false, search = false, unique = false) {
    return apiConnection
      .put(
        "/app/admin/" +
          (generic ? "generic/" : "") +
          encodeURI(alias) +
          (search ? "/search" : "") +
          "/" +
          (unique ? "unique-" : "") +
          "post" +
          (id ? "/" + id : ""),
        params,
      )
      .then((response) => response);
  }

  putPost(alias, generic = false, params = {}, id = null) {
    const url = "/app/admin/" + (generic ? "generic/" : "") + encodeURI(alias) + "/post" + (id ? "/" + id : "");
    return id ? apiConnection.put(url, params) : apiConnection.post(url, params);
  }
  post(alias, id = null, params = {}, generic = false, search = false, unique = false) {
    return apiConnection
      .post(
        "/app/admin/" +
          (generic ? "generic/" : "") +
          encodeURI(alias) +
          (search ? "/search" : "") +
          "/" +
          (unique ? "unique-" : "") +
          "post" +
          (id ? "/" + id : ""),
        params,
      )
      .then((response) => response);
  }

  switchUser(id, studeaManager = false) {
    loginManager.storeInitialToken();

    return new Promise((resolve) => {
      apiConnection.get("/app" + (studeaManager ? "/studea-manager" : "/user") + "/switch/" + id).then((response) => {
        if (response.token && response.refreshToken && response.expires) {
          window.sessionStorage.setItem("studea-switchToken", response.token);
          window.sessionStorage.setItem("studea-switchRefreshToken", response.refreshToken);
          window.sessionStorage.setItem("studea-switchExpires", response.expires);
          resolve(response);
        }
      });
    });
  }

  copy(alias, id, tradGender = 1, generic = true, params = {}) {
    const url = "/app/admin" + (generic ? "/generic/" : "/") + alias + "/copy/" + id;
    const tradPrefix = stringManager.toCamelCase(alias);
    return apiConnection.post(url, params).then((response) => {
      if (response) {
        notificationManager.showNotification(
          "success",
          i18n.global.tc("global.copy.success", tradGender, {
            name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 2),
          }),
        );
      }
    });
  }

  notification(alias, userId) {
    const url = "/app/admin/" + alias + "/notification/" + userId;
    return apiConnection.put(url).then((response) => {
      if (response) {
        notificationManager.showNotification("success", i18n.global.t("admin.activate_notification_success"));
      }
    });
  }

  remove(alias, id, tradGender = 1, generic = true, archive = false) {
    const url =
      "/app/admin" + (generic ? "/generic" : "") + "/" + alias + "/" + (archive ? "archive" : "delete") + "/" + id;

    const tradPrefix = stringManager.toCamelCase(alias);

    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "error",
          i18n.global.tc("global.delete.title", tradGender, {
            name: i18n.global.tc("admin." + tradPrefix + ".title", 1).toLowerCase(),
          }),
          i18n.global.tc("global.delete.sub_title", tradGender, {
            name: i18n.global.tc("admin." + tradPrefix + ".title", 1).toLowerCase(),
          }),
          true,
          true,
        )
        .then((data) => {
          if (data.isConfirmed) {
            apiConnection.delete(url, {}).then((data) => {
              resolve(data);
              if (data.success) {
                notificationManager.showNotification(
                  data.hasError ? "error" : "success",
                  data.hasError
                    ? data.detail[0].message
                    : i18n.global.tc("global.delete.success", tradGender, {
                        name: i18n.global.tc("admin." + tradPrefix + ".title", 1),
                      }),
                );
              } else if (!data.success && data.message) {
                notificationManager.showNotification("error", data.message);
              }
            });
          }
        });
    });
  }

  removeTraining(row) {
    let trainings = "";
    if (row.row && row.row[4]) {
      Object.values(row.row[4]).forEach((element, index) => {
        trainings = trainings + (index !== 0 ? ", " : "") + element.label;
      });
    }
    const url = "/app/admin/training/delete/" + row.id;
    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "error",
          i18n.global.tc("global.delete.title", 2, {
            name: i18n.global.tc("admin.trainingCourse.title", 1).toLowerCase(),
          }),
          i18n.global.tc("global.delete.sub_title", 2, {
            name: i18n.global.tc("admin.trainingCourse.title", 1).toLowerCase(),
          }) +
            "\n" +
            (trainings && trainings.length
              ? i18n.global.t("admin.training.confirmation_subtitle") + " : " + trainings
              : ""),
          true,
          true,
        )
        .then((data) => {
          if (data.isConfirmed) {
            apiConnection.delete(url, {}).then((data) => {
              resolve(data);
              if (data.success) {
                notificationManager.showNotification(
                  data.hasError ? "error" : "success",
                  data.hasError
                    ? data.detail[0].message
                    : i18n.global.tc("global.delete.success", 2, {
                        name: i18n.global.tc("admin.training.title", 1),
                      }),
                );
              } else if (!data.success && data.message) {
                notificationManager.showNotification("error", data.message);
              }
            });
          }
        });
    });
  }

  duplicate(alias, id, tradGender = 1, params = []) {
    const url = "/app/admin/" + alias + "/duplicate/" + id;

    const tradPrefix = stringManager.toCamelCase(alias);

    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "error",
          i18n.global.tc("global.copy.title", tradGender, {
            name: i18n.global.tc("admin." + tradPrefix + ".title", 1).toLowerCase(),
          }),
          i18n.global.tc("global.copy.sub_title", tradGender, {
            name: i18n.global.tc("admin." + tradPrefix + ".title", 1).toLowerCase(),
          }),
          true,
          true,
        )
        .then((data) => {
          if (data.isConfirmed) {
            apiConnection.get(url, params).then((data) => {
              resolve(data);
              if (data.success) {
                notificationManager.showNotification(
                  data.hasError ? "error" : "success",
                  data.hasError
                    ? data.detail[0].message
                    : i18n.global.tc("global.copy.success", tradGender, {
                        name: i18n.global.tc("admin." + tradPrefix + ".title", 1),
                      }),
                );
              } else if (!data.success && data.message) {
                notificationManager.showNotification("error", data.message);
              }
            });
          }
        });
    });
  }

  importForm(alias) {
    return apiConnection.get("/app/admin/" + encodeURI(alias) + "/import-form").then((response) => response);
  }

  exportForm(alias) {
    return apiConnection.get("/app/admin/" + encodeURI(alias) + "/export-form").then((response) => response);
  }

  postExport(alias, params) {
    return apiConnection.post("/app/admin/" + encodeURI(alias) + "/export-post", params).then((response) => response);
  }

  generateTriadTest() {
    return apiConnection.get(URL_GENERATE_TRIAD_TEST).then((response) => response);
  }

  generateTrainingTest() {
    return apiConnection.get(URL_GENERATE_TRAINING_TEST).then((response) => response);
  }

  getLastPasswordLinkEmail(id) {
    return apiConnection.get(URL_USER_LAST_PASSWORD_LINK + id).then((response) => response);
  }

  getDuplicatedUserList(params) {
    return apiConnection.get("/app/admin/user/duplicated/list", params).then((response) => response);
  }

  exportStatistic() {
    return apiConnection.get("/app/admin/statistic/export/questionnaire_completion_rate").then((response) => {
      messengerMessageManager.processMessage(response);
    });
  }

  exportStatisticFromIndicator(indicator) {
    return apiConnection.get("/app/admin/statistic/export/" + indicator.download).then((response) => {
      messengerMessageManager.processMessage(response);
    });
  }

  exportInstitutionAnswers(id) {
    return apiConnection.get("/app/admin/institution/export-excel-post/" + id).then((response) => {
      messengerMessageManager.processMessage(response);
    });
  }

  exportComponentAnswers(id) {
    return apiConnection.get("/app/admin/institution/export-excel-post/component/" + id).then((response) => {
      messengerMessageManager.processMessage(response);
    });
  }

  exportInstitution(id) {
    return apiConnection.get("/app/admin/institution/export-post/" + id).then((response) => {
      messengerMessageManager.processMessage(response);
    });
  }

  generateAllRncpSkillReferential() {
    return apiConnection.get("/app/admin/skill/create-all-skill-referential-rncp").then((response) => response);
  }

  deleteAllTriadFromTrainingCourse(trainingCourseId) {
    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "error",
          i18n.global.t("admin.triad.delete_all_triad.title"),
          i18n.global.t("admin.triad.delete_all_triad.confirmation"),
          true,
          true,
        )
        .then((response) => {
          if (response.isConfirmed) {
            apiConnection
              .delete(URL_TRAINING_COURSE + "/" + trainingCourseId + "/delete-all-triads")
              .then((response) => {
                resolve(response);
                if (response.success) {
                  notificationManager.showNotification(
                    "success",
                    i18n.global.t("admin.triad.delete_all_triad.success"),
                  );
                }
              });
          }
        });
    });
  }

  switchEnableSkillAdminConfigOnAllTrainingCourses(type) {
    notificationManager
      .showAlert(
        "warning",
        type === "admin-config"
          ? i18n.global.t("admin_config.enable_on_all_training_course.confirm.title")
          : i18n.global.t("admin_config.disable_on_all_training_course.confirm.title"),
        type === "admin-config"
          ? i18n.global.t("admin_config.enable_on_all_training_course.confirm.subtitle")
          : i18n.global.t("admin_config.disable_on_all_training_course.confirm.subtitle"),
        true,
        true,
      )
      .then((response) => {
        if (response.isConfirmed) {
          apiConnection.get("/app/admin/skill/config/" + type).then((response) => {
            if (response.success) {
              notificationManager.showNotification(
                "success",
                i18n.global.t("studea_manager.skill_configuration.success"),
              );
            }
          });
        }
      });
  }

  sort(alias, id, position, generic = true, type = null) {
    const url = "/app/admin/" + (generic ? "generic/" : "") + alias + "/sort/" + id + "/" + position;
    const tradPrefix = stringManager.toCamelCase(alias);
    let params = {};
    if (type) {
      params["type"] = type;
    }

    return apiConnection.put(url, params).then((response) => {
      if (response) {
        notificationManager.showNotification(
          "success",
          i18n.global.t("global.sort.success", {
            name: i18n.global.tc("admin." + tradPrefix + ".title", 2).toLowerCase(),
          }),
        );
      }
    });
  }

  synchronizeAmmon() {
    return apiConnection.get("/app/admin/ammon/synchronize").then((res) => res);
  }

  postAmmonConfig(result) {
    return apiConnection.put("/app/admin/generic/ammon_config/unique-post", result).then((res) => res);
  }

  getYpareoDirectories() {
    return apiConnection.get("/app/admin/modules/ypareo_config/directory/refresh").then((response) => {
      if (!response.success) {
        notificationManager.showAlert("warning", response.message);
      }
    });
  }

  postUniserviceImport(data) {
    return apiConnection.post("/app/admin/uniservice/import-post", data).then((res) => res);
  }

  postAbsenceModuleConfig(data) {
    return apiConnection.post("/app/admin/absence/config/post", data).then((res) => res);
  }

  postArchiveTraining(data) {
    return apiConnection.post("/app/admin/training-course/archive/post", data).then((res) => res);
  }

  postNewTrainingCourseCurrentYear(data) {
    return apiConnection.post("/app/admin/training-course/edit/current-year/post", data).then((res) => res);
  }

  putRegistrationTabForm(dataVersion, data, modalId) {
    return apiConnection.put("/app/admin/registration/tab/" + dataVersion + "/put/" + modalId, data).then((res) => res);
  }

  putRegistrationStep(dataVersion, data, modalId) {
    return apiConnection
      .put("/app/admin/registration/step/" + dataVersion + "/put/" + modalId, data)
      .then((res) => res);
  }
}

export const adminManager = new AdminManager();
